export default __webpack_public_path__ + "static/slider_2-37c20cf28b0d664687d9977f1a4a023f.jpg";